import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';

import SocialMediaItem, {
  ISocialMediaItem,
} from './socialMediaItem/SocialMediaItem';

export interface ISocialMediaTeaser {
  headline?: string;
  items: ISocialMediaItem[];
  component: string;
  _uid: string;
  _editable?: string;
}

export default function SocialMediaTeaser(props: ISocialMediaTeaser) {
  const { headline, items } = props;

  const cssClass = clsx(
    'bg-white pb-15px px-15px sm:pt-[30px] md:px-60px lg:pt-[100px]'
  );

  return (
    <div {...sbEditable(props)} className={cssClass}>
      <h2>{headline}</h2>
      <div
        className={clsx(
          'flex flex-col flex-wrap sm:mb-40px md:flex-row md:mt-40px',
          items.length > 2 && 'justify-between'
        )}
      >
        {items &&
          items.length > 0 &&
          items.map((item) => (
            <SocialMediaItem
              key={item._uid}
              item={item}
              itemsLength={items.length}
            />
          ))}
      </div>
    </div>
  );
}
